import { shuffle } from 'lodash-es';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_schoolTypes as SchoolTypes } from '@/__generated__/getSearchResults';

const SCHOOL_TYPE: Record<string, string> = {
  preschool: 'Preschool',
  kindergarten: 'Kindergarten',
  inHomeFamily: 'In-Home daycare',
  dayCare: 'Day Care',
  childCareDayCare: 'Child care',
};

const convertSchoolTypesToStrings = (types: SchoolTypes): string[] => {
  return Object.entries(types)
    .filter(([type, value]) => value === true && SCHOOL_TYPE[type])
    .map(([key]) => SCHOOL_TYPE[key]);
};

const shuffleSchoolTypes = (types: SchoolTypes | null): string[] => {
  if (!types) return [];

  const mapTypes = convertSchoolTypesToStrings(types);

  return shuffle(mapTypes).slice(0, 3);
};

export default shuffleSchoolTypes;
